<ion-chip mode="ios" [color]="colorBg" class="getm-left-label-card">
  <ng-container *ngIf="icon && icon.length > 0">
    <ion-icon [name]="icon" [color]="iconColor"></ion-icon>
  </ng-container>

  <ng-container *ngIf="text && text.length > 0">
    <ion-label
      [color]="textColor"
      [innerHTML]="text | htmlSeguro"
      [ngStyle]="{ 'max-width': icon && icon.length > 0 ? '68px' : '100%' }"
    ></ion-label>
  </ng-container>
</ion-chip>
